<div class="m-option">
    <m-popup :open.sync="open"
             :padding="false"
             :placement="placement"
             :disabled="disabled"
             :close-on-backdrop="true"
             :background="false"
             :shadow="false"
             :focus-management="focusManagement"
             @open="onOpen"
             @close="onClose">
        <button v-if="isSkinMixed"
                class="m-option__button"
                @click="onClick"
                :id="id"
                aria-haspopup="true"
                :aria-controls="ariaControls"
                :aria-expanded="open"
                :disabled="disabled"
                slot="trigger">
            <m-icon :title="propTitle"
                    name="m-svg__options">
            </m-icon>
        </button>
        <m-icon-button :id="id"
                       v-else
                       aria-haspopup="true"
                       :aria-controls="ariaControls"
                       :aria-expanded="open"
                       slot="trigger"
                       :skin="iconButtonSkin"
                       :title="propTitle"
                       icon-name="m-svg__options"
                       :disabled="disabled"
                       :button-size="size"
                       @click="onClick" />
        <ul :id="ariaControls"
            class="m-option__list"
            :style="{ maxHeight: menuMaxHeight, maxWidth: optionMaxWidth }"
            :aria-labelledby="id"
            ref="menu">
            <slot></slot>
        </ul>
    </m-popup>
</div>
